/* Modified from https://github.com/taylorhakes/fecha
 * Imported mostly 1:1 from uikit legacy
 * MIT License (c) 2015 Taylor Hakes
 */

/*eslint-disable*/
// 把 YYYY-MM-DD 改成了 yyyy-MM-dd

const token = /d{1,4}|M{1,4}|yy(?:yy)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
const twoDigits = /\d\d?/;
const threeDigits = /\d{3}/;
const fourDigits = /\d{4}/;
const word = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;

const noop = () => { };
const pad = (val, len = 2) => String(val).padStart(len, '0');

const shorten = (arr, sLen) => arr.map((x) => x.substr(0, sLen));
const monthUpdate = (arrName) => (d, v, i18n) => {
    const index = i18n[arrName].indexOf(
        v.charAt(0).toUpperCase() + v.substr(1).toLowerCase()
    );
    if (~index) d.month = index;
};

const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];
const monthNamesShort = shorten(monthNames, 3);
const dayNamesShort = shorten(dayNames, 3);

export const i18n = {
    dayNamesShort,
    dayNames,
    monthNamesShort,
    monthNames,
    amPm: ['am', 'pm'],
    DoFn(D) {
        return D + ['th', 'st', 'nd', 'rd'][D % 10 > 3 ? 0 : (D - D % 10 !== 10) * D % 10];
    }
};

const formatFlags = {
    D: (d) => d.getDay(),
    DD: (d) => pad(d.getDay()),
    Do: (d, i18n) => i18n.DoFn(d.getDate()),
    d: (d) => d.getDate(),
    dd: (d) => pad(d.getDate()),
    ddd: (d, i18n) => i18n.dayNamesShort[d.getDay()],
    dddd: (d, i18n) => i18n.dayNames[d.getDay()],
    M: (d) => d.getMonth() + 1,
    MM: (d) => pad(d.getMonth() + 1),
    MMM: (d, i18n) => i18n.monthNamesShort[d.getMonth()],
    MMMM: (d, i18n) => i18n.monthNames[d.getMonth()],
    yy: (d) => String(d.getFullYear()).substr(2),
    yyyy: (d) => d.getFullYear(),
    h: (d) => d.getHours() % 12 || 12,
    hh: (d) => pad(d.getHours() % 12 || 12),
    H: (d) => d.getHours(),
    HH: (d) => pad(d.getHours()),
    m: (d) => d.getMinutes(),
    mm: (d) => pad(d.getMinutes()),
    s: (d) => d.getSeconds(),
    ss: (d) => pad(d.getSeconds()),
    S: (d) => Math.round(d.getMilliseconds() / 100),
    SS: (d) => pad(Math.round(d.getMilliseconds() / 10), 2),
    SSS: (d) => pad(d.getMilliseconds(), 3),
    a: (d, i18n) => d.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1],
    A: (d, i18n) => d.getHours() < 12 ? i18n.amPm[0].toUpperCase() : i18n.amPm[1].toUpperCase(),
    ZZ: (d) => {
        const o = d.getTimezoneOffset();
        return (o > 0 ? '-' : '+') +
            pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4);
    }
};

export const masks = {
    default: 'ddd MMM dd yyyy HH:mm:ss',
    shortDate: 'M/D/yy',
    mediumDate: 'MMM d, yyyy',
    longDate: 'MMMM d, yyyy',
    fullDate: 'dddd, MMMM d, yyyy',
    shortTime: 'HH:mm',
    mediumTime: 'HH:mm:ss',
    longTime: 'HH:mm:ss.SSS'
};

export function format(dateObj, mask, i18nSettings) {
    const i18nLocal = i18nSettings || i18n;
    if (typeof dateObj === 'number') dateObj = new Date(dateObj);
    if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
        throw new Error('Invalid Date in fecha.format');
    }
    mask = masks[mask] || mask || masks.default;
    return mask.replace(token, ($0) =>
        $0 in formatFlags ? formatFlags[$0](dateObj, i18nLocal) : $0.slice(1, -1)
    );
}

const parseFlags = {
    d: [twoDigits, (d, v) => { d.day = v; }],
    M: [twoDigits, (d, v) => { d.month = v - 1; }],
    yy: [twoDigits, (d, v) => {
        const da = new Date();
        const cent = +('' + da.getFullYear()).substr(0, 2);
        d.year = '' + (v > 68 ? cent - 1 : cent) + v;
    }],
    h: [twoDigits, (d, v) => { d.hour = v; }],
    m: [twoDigits, (d, v) => { d.minute = v; }],
    s: [twoDigits, (d, v) => { d.second = v; }],
    yyyy: [fourDigits, (d, v) => { d.year = v; }],
    S: [/\d/, (d, v) => { d.millisecond = v * 100; }],
    SS: [/\d{2}/, (d, v) => { d.millisecond = v * 10; }],
    SSS: [threeDigits, (d, v) => { d.millisecond = v; }],
    D: [twoDigits, noop],
    ddd: [word, noop],
    MMM: [word, monthUpdate('monthNamesShort')],
    MMMM: [word, monthUpdate('monthNames')],
    a: [word, (d, v, i18n) => {
        const val = v.toLowerCase();
        if (val === i18n.amPm[0]) d.isPm = false;
        else if (val === i18n.amPm[1]) d.isPm = true;
    }],
    ZZ: [/[\+\-]\d\d:?\d\d/, (d, v) => {
        const parts = (v + '').match(/([\+\-]|\d\d)/gi);
        if (parts) {
            const minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
            d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
        }
    }]
};
parseFlags.DD = parseFlags.D;
parseFlags.dddd = parseFlags.ddd;
parseFlags.Do = parseFlags.dd = parseFlags.d;
parseFlags.mm = parseFlags.m;
parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
parseFlags.MM = parseFlags.M;
parseFlags.ss = parseFlags.s;
parseFlags.A = parseFlags.a;

export function parse(dateStr, format, i18nSettings) {
    const i18nLocal = i18nSettings || i18n;
    if (typeof format !== 'string') throw new Error('Invalid format in fecha.parse');
    format = masks[format] || format;
    if (dateStr.length > 1000) return false;

    let isValid = true;
    const dateInfo = {};
    format.replace(token, ($0) => {
        if (parseFlags[$0]) {
            const info = parseFlags[$0];
            const index = dateStr.search(info[0]);
            if (!~index) isValid = false;
            else {
                dateStr.replace(info[0], (result) => {
                    info[1](dateInfo, result, i18nLocal);
                    dateStr = dateStr.substr(index + result.length);
                    return result;
                });
            }
        }
        return parseFlags[$0] ? '' : $0.slice(1, -1);
    });
    if (!isValid) return false;

    const today = new Date();
    if (dateInfo.isPm === true && dateInfo.hour != null && +dateInfo.hour !== 12)
        dateInfo.hour = +dateInfo.hour + 12;
    else if (dateInfo.isPm === false && +dateInfo.hour === 12)
        dateInfo.hour = 0;

    let date;
    if (dateInfo.timezoneOffset != null) {
        dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
        date = new Date(Date.UTC(
            dateInfo.year || today.getFullYear(),
            dateInfo.month || 0,
            dateInfo.day || 1,
            dateInfo.hour || 0,
            dateInfo.minute || 0,
            dateInfo.second || 0,
            dateInfo.millisecond || 0
        ));
    } else {
        date = new Date(
            dateInfo.year || today.getFullYear(),
            dateInfo.month || 0,
            dateInfo.day || 1,
            dateInfo.hour || 0,
            dateInfo.minute || 0,
            dateInfo.second || 0,
            dateInfo.millisecond || 0
        );
    }
    return date;
}

export default { format, parse, masks, i18n };
